import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/capacitor';

@Injectable({ providedIn: 'root' })
export class SentryService {
  capture(error: any, context: string = '') {
    Sentry.captureException(error, {
      tags: { context }
    });
  }

  setUser(user: { id: string; email?: string; username?: string }) {
    Sentry.setUser(user);
  }

  setTag(key: string, value: string) {
    Sentry.setTag(key, value);
  }

  setContext(name: string, context: any) {
    Sentry.setContext(name, context);
  }
}
